<div class="flex h-[88px] relative bg-[#eee] px-5 2xl:px-6 3xl:px-10 ig-topbar" role="region"
  [attr.aria-label]="'Top navigation bar'"
  [class.script-desktop-sm]="mediaQueryService.isDesktopSm$ | async"
  [class.script-desktop-lg]="mediaQueryService.isDesktopLg$ | async"
  [class.script-desktop-xl]="mediaQueryService.isDesktopXl$ | async"
  [class.script-desktop-2xl]="mediaQueryService.isDesktop2Xl$ | async"
  [class.script-desktop-3xl]="mediaQueryService.isDesktop3Xl$ | async">
  <div class="ig-pos-wrap min-w-[190px] relative flex-[3] 2xl:max-w-[200px] 2xl:pl-0" role="region" aria-label="Current view">
    <div class="ig-viewing ext-gray-700 text-sm mt-4">YOU ARE NOW VIEWING</div>
    <div class="ig-at text-gray-600 text-3xl font-semibold" aria-live="polite">{{command.isEventCalendar ? 'EVENTS' :
      'PLACES'}}</div>
  </div>
  <div class="flex-[16] 2xl:flex-[14] flex gap-4 justify-center items-center btn-wrap" role="toolbar" aria-label="View controls">
    <ng-container *ngIf="command.isEventCalendar">
      <ig-event-date-filter mode="dropdown" menuClass="ig-date-filter"
        (dateSelected)="filterEventsByDate($event)"></ig-event-date-filter>
      <ig-event-location-filter *ngIf="settings.toggle.eventLocationFilter" mode="dropdown"></ig-event-location-filter>
      <ig-multi-select-event-category-filter role="combobox" aria-haspopup="listbox"></ig-multi-select-event-category-filter>
    </ng-container>

    <ng-container *ngIf="!command.isEventCalendar">
      <ig-custom-default-place-category-filter [isOnlyShowNodeFromUrl]="true"></ig-custom-default-place-category-filter>
      <ig-favorite-custom-place-filter></ig-favorite-custom-place-filter>
      <ig-place-location-filter *ngIf="settings.toggle.placeLocationFilter" mode="dropdown"></ig-place-location-filter>
    </ng-container>

    <div class="1200:flex hidden flex-col gap-1.5 ig-view-switcher">
      <ig-accordion #viewSwitcher mode="dropdown" class="ig-view-switcher-dropdown" [canItemClear]="false" [title]="'SELECT VIEW'"
        [menuClass]="'ig-view-switcher-menu'">
        <ng-container dropdown>
          <div role="menu" aria-label="View options">
            <button mat-menu-item type="button" role="menuitemradio" (click)="selectTopBarMapView($event, viewSwitcher)"
              [attr.aria-checked]="command.isMapView">
              <span class="flex w-full items-center justify-between gap-3">
                <span>VIEW ON MAP</span>
                <mat-icon *ngIf="command.isMapView" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
              </span>
            </button>
            <button mat-menu-item type="button" role="menuitemradio"
              (click)="selectTopBarCardView($event, viewSwitcher)"
              [attr.aria-checked]="isCardViewActive">
              <span class="flex w-full items-center justify-between gap-3">
                <span>CARD VIEW</span>
                <mat-icon *ngIf="isCardViewActive" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
              </span>
            </button>
            <ng-container *ngIf="command.isEventCalendar">
              <button *ngIf="settings?.toggle?.calendarViewLayout" mat-menu-item type="button" role="menuitemradio"
                (click)="selectTopBarEventLayout($event, 'calendar', viewSwitcher)"
                [attr.aria-checked]="!command.isMapView && topBarActiveEventLayoutStyle === 'calendar'">
                <span class="flex w-full items-center justify-between gap-3">
                  <span>CALENDAR VIEW</span>
                  <mat-icon *ngIf="!command.isMapView && topBarActiveEventLayoutStyle === 'calendar'" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
                </span>
              </button>
              <button *ngIf="settings?.toggle?.calendarViewLayout" mat-menu-item type="button" role="menuitemradio"
                (click)="selectTopBarEventLayout($event, 'list', viewSwitcher)"
                [attr.aria-checked]="!command.isMapView && topBarActiveEventLayoutStyle === 'list'">
                <span class="flex w-full items-center justify-between gap-3">
                  <span>LIST VIEW</span>
                  <mat-icon *ngIf="!command.isMapView && topBarActiveEventLayoutStyle === 'list'" class="!text-[18px] !w-[18px] !h-[18px] !m-0 !text-[#65a30d]">check</mat-icon>
                </span>
              </button>
            </ng-container>
          </div>
        </ng-container>
      </ig-accordion>
      </div>
    <div class="text-center max-w-[40px] hidden 2xl:block">OR</div>

    <ig-search-field [value]="searchText" label="search {{command.isEventCalendar ? 'events' : 'places'}}"
      [formControl]="searchControl" class="mt-[11px] 1340:block hidden" role="search"></ig-search-field>
    <ig-button class="1440:block hidden" (trigger)="addEventsManually()" icon="input"
      [ariaLabel]="command.isEventCalendar ? 'Submit your event' : 'Submit your place'">
      <span class="text-sm">SUBMIT YOUR {{command.isEventCalendar ? 'EVENT' : 'PLACE'}}</span>
    </ig-button>


    <button
      type="button"
      class="1440:hidden h-11 w-11 max-w-[44px] bg-white shadow-md rounded-md flex items-center px-4 justify-between text-sm p-4 outline-orange-400 outline-offset-2 outline-4"
      matTooltip="More options"
      [matMenuTriggerFor]="menu"
      aria-label="More options"
      matRipple
      [matRippleCentered]="true"
      [matRippleColor]="'rgba(255, 255, 255, 0.1)'"
      [class.outline]="searchControl.value">
        <mat-icon class="text-gray-500 text-lg relative right-0.5" aria-hidden="true">more_vert</mat-icon>
    </button>

      <mat-menu #menu="matMenu" class="ig-accordion-menu ig-tb-more {{menuClass}}">

        <button class="1200:!hidden ig-default-btn-color ig-menu-btn" mat-menu-item
          (click)="viewChange()" [attr.aria-label]="command.isMapView ? 'Switch to list view' : 'Switch to map view'">{{command.isMapView ? 'CLICK FOR LIST VIEW' : 'CLICK FOR MAP VIEW'}}</button>
        <div class="1200:!hidden text-center mt-4 mb-2 text-gray-400">- OR -</div>
        <div class="1340:!hidden mb-5">
          <ig-search-field [value]="searchText" label="search {{command.isEventCalendar ? 'events' : 'places'}}"
            [formControl]="searchControl" class="mt-[11px]" role="search"></ig-search-field>
        </div>
        <button mat-menu-item class="!mt-2 ig-default-btn-color ig-menu-btn" (click)="addEventsManually()"
          [attr.aria-label]="command.isEventCalendar ? 'Submit your event' : 'Submit your place'">SUBMIT YOUR
          {{command.isEventCalendar ? 'EVENT' : 'PLACE'}}</button>

      </mat-menu>
    <ig-powered-by class="flex justify-end"></ig-powered-by>
  </div>

</div>

<div class="w-full h-2 bar-underline" role="separator" aria-hidden="true"></div>
